import { render } from "./TournamentMatchBoard.vue?vue&type=template&id=50010920&ts=true"
import script from "./TournamentMatchBoard.vue?vue&type=script&lang=ts"
export * from "./TournamentMatchBoard.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__